// ---- Header scroll state ----
const header = document.querySelector('.site-header');
const isLightPage = document.body.classList.contains('light-page');
function updateHeader(){
  if (isLightPage){ header.classList.add('light-page'); return; }
  if (window.scrollY > 80) header.classList.add('solid');
  else header.classList.remove('solid');
}
if (header){ updateHeader(); window.addEventListener('scroll', updateHeader, {passive:true}); }

// ---- Supabase form handler: file → Storage, fields → receipt_submissions ----
const SB_FIELD_MAP = {
  'Order number': 'order_number',
  'email': 'email',
  'name': 'name',
  'Amount paid': 'amount',
  'Date of transfer': 'date_of_transfer',
  'Sender bank': 'sender_bank',
  'Notes': 'notes'
};

const SB_CONTACT = 'Please try again or email hello@lsjregal.com.';

function friendlySupabaseError(rawText, context){
  let data = null;
  try { data = JSON.parse(rawText); } catch(_){ }
  const code = data?.code || data?.statusCode;
  const msg  = (data?.message || '').toLowerCase();

  if (context === 'upload'){
    if (msg.includes('bucket not found')) return 'We could not save your file right now. ' + SB_CONTACT;
    if (msg.includes('payload too large') || msg.includes('exceeded')) return 'Your file is too large. Please attach something under 10 MB.';
    if (msg.includes('mime') || msg.includes('not allowed')) return 'That file type is not accepted. Please upload a PNG, JPEG, WEBP, HEIC or PDF.';
    if (msg.includes('row-level security') || msg.includes('permission')) return 'We could not save your file right now. ' + SB_CONTACT;
    return 'We could not upload your file. ' + SB_CONTACT;
  }

  if (code === '23505') return 'We have already received a submission with this order number. If you need to send an update, please email hello@lsjregal.com.';
  if (code === '23502') return 'Please make sure every required field is filled in, then try again.';
  if (code === '23514') return 'One of the values you entered is not valid. Please check the form and try again.';
  if (code === 'PGRST204' || code === 'PGRST205') return 'Something on our end is misconfigured. We are looking into it — please email hello@lsjregal.com in the meantime.';
  if (msg.includes('row-level security') || msg.includes('permission')) return 'We could not save your submission right now. ' + SB_CONTACT;
  return 'We could not save your submission. ' + SB_CONTACT;
}

document.addEventListener('submit', async (e) => {
  const form = e.target.closest('[data-supabase-form]');
  if (!form) return;
  e.preventDefault();

  const SB_URL = window.LSJ_SUPABASE_URL;
  const SB_KEY = window.LSJ_SUPABASE_KEY;
  const btn = form.querySelector('[type=submit]');
  const original = btn ? btn.textContent : '';
  const errorEl = form.querySelector('[data-w3-error]');
  const wrap = form.closest('[data-w3-wrap]');
  const successEl = wrap?.querySelector('[data-w3-success]');

  if (errorEl){ errorEl.hidden = true; errorEl.textContent = ''; }
  if (btn){ btn.disabled = true; btn.textContent = 'Sending…'; }

  try {
    if (!SB_URL || !SB_KEY) throw new Error('Form delivery is not set up yet. ' + SB_CONTACT);

    const formType = form.dataset.formType || 'submission';
    const fileInput = form.querySelector('input[type=file]');
    const files = fileInput?.files ? Array.from(fileInput.files) : [];
    const maxFiles = parseInt(fileInput?.dataset.maxFiles || '0', 10);
    if (maxFiles > 0 && files.length > maxFiles){
      throw new Error(`Please attach no more than ${maxFiles} file${maxFiles === 1 ? '' : 's'}.`);
    }
    const uploadedUrls = [];

    for (const file of files){
      if (file.size > 10 * 1024 * 1024) throw new Error(`"${file.name}" is larger than 10 MB. Please attach a smaller version.`);
      const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
      const path = `${formType}/${Date.now()}-${Math.random().toString(36).slice(2,8)}-${safeName}`;
      const up = await fetch(`${SB_URL}/storage/v1/object/receipts/${path}`, {
        method: 'POST',
        headers: {
          'apikey': SB_KEY,
          'Authorization': `Bearer ${SB_KEY}`,
          'Content-Type': file.type || 'application/octet-stream',
          'x-upsert': 'false'
        },
        body: file
      });
      if (!up.ok){
        throw new Error(friendlySupabaseError(await up.text(), 'upload'));
      }
      uploadedUrls.push(`${SB_URL}/storage/v1/object/public/receipts/${path}`);
    }
    const receiptUrl = uploadedUrls[0] || null;
    const extraFileUrls = uploadedUrls.slice(1);

    const fd = new FormData(form);
    const row = { form_type: formType, receipt_url: receiptUrl };
    const extras = [];
    for (const [k, v] of fd.entries()){
      if (fileInput && k === fileInput.name) continue;
      if (typeof v !== 'string') continue;
      const trimmed = v.trim();
      if (!trimmed) continue;
      const col = SB_FIELD_MAP[k];
      if (col){
        row[col] = trimmed;
      } else {
        extras.push(`${k}: ${trimmed}`);
      }
    }
    if (extras.length){
      row.notes = (row.notes ? row.notes + '\n\n' : '') + extras.join('\n');
    }
    if (extraFileUrls.length){
      const fileList = extraFileUrls.map((u, i) => `Attachment ${i + 2}: ${u}`).join('\n');
      row.notes = (row.notes ? row.notes + '\n\n' : '') + fileList;
    }

    const ins = await fetch(`${SB_URL}/rest/v1/receipt_submissions`, {
      method: 'POST',
      headers: {
        'apikey': SB_KEY,
        'Authorization': `Bearer ${SB_KEY}`,
        'Content-Type': 'application/json',
        'Prefer': 'return=minimal'
      },
      body: JSON.stringify(row)
    });
    if (!ins.ok){
      throw new Error(friendlySupabaseError(await ins.text(), 'insert'));
    }

    form.hidden = true;
    if (successEl){
      successEl.hidden = false;
      successEl.scrollIntoView({behavior:'smooth', block:'start'});
    }
  } catch (err){
    const msg = err?.message || 'Something went wrong. ' + SB_CONTACT;
    if (errorEl){
      errorEl.textContent = msg;
      errorEl.hidden = false;
    } else {
      alert(msg);
    }
  } finally {
    if (btn){ btn.disabled = false; btn.textContent = original; }
  }
});

// ---- Collection filter + sort: navigate on change ----
(function(){
  const form = document.querySelector('[data-filter-form]');
  if (!form) return;
  form.addEventListener('change', (e) => {
    if (!e.target.matches('select, input[type=checkbox], input[type=radio]')) return;
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form).entries()){
      if (v && String(v).trim() !== '') params.set(k, v);
    }
    const qs = params.toString();
    window.location.href = window.location.pathname + (qs ? '?' + qs : '');
  });
})();

// ---- Announcement bar: hide on scroll down, reveal on scroll up ----
(function(){
  let lastY = window.scrollY;
  const THRESHOLD = 4;
  const HIDE_AFTER = 80;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y > HIDE_AFTER && y > lastY + THRESHOLD){
      document.body.classList.add('promo-hidden');
    } else if (y < lastY - THRESHOLD || y < HIDE_AFTER){
      document.body.classList.remove('promo-hidden');
    }
    lastY = y;
  }, {passive:true});
})();

// ---- Hero slideshow ----
const slides = document.querySelectorAll('.hero-slide');
const dots = document.querySelectorAll('.hero-dots button');
let slideIdx = 0;
function showSlide(i){
  slides.forEach((s,n)=>s.classList.toggle('active', n===i));
  dots.forEach((d,n)=>d.classList.toggle('active', n===i));
  slideIdx = i;
}
if (slides.length){
  setInterval(()=>showSlide((slideIdx+1)%slides.length), 6500);
  dots.forEach((d,n)=>d.addEventListener('click', ()=>showSlide(n)));
}

// ---- Countdown ----
const countdownEl = document.getElementById('countdown');
if (countdownEl){
  const target = new Date();
  target.setDate(target.getDate()+7);
  target.setHours(target.getHours()+8, target.getMinutes()+22);
  function tick(){
    const diff = target - new Date();
    if (diff <= 0) return;
    const days = Math.floor(diff/86400000);
    const hours = Math.floor(diff/3600000)%24;
    const mins = Math.floor(diff/60000)%60;
    const secs = Math.floor(diff/1000)%60;
    const pad = n => String(n).padStart(2,'0');
    countdownEl.querySelector('[data-d]').textContent = pad(days);
    countdownEl.querySelector('[data-h]').textContent = pad(hours);
    countdownEl.querySelector('[data-m]').textContent = pad(mins);
    countdownEl.querySelector('[data-s]').textContent = pad(secs);
  }
  tick();
  setInterval(tick,1000);
}

// ---- Fade-in observer ----
const io = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{
    if (e.isIntersecting){ e.target.classList.add('visible'); io.unobserve(e.target); }
  });
},{threshold:0.12});
document.querySelectorAll('.fade-in').forEach(el=>io.observe(el));

// ---- Cart (Shopify is source of truth) ----
try { localStorage.removeItem('lsj_cart'); } catch(e){}

const CART_SECTION = 'cart-drawer';

function updateCartCount(){
  return fetch('/cart.js', {headers:{'Accept':'application/json'}})
    .then(r=>r.json())
    .then(data=>{
      const total = data.item_count || 0;
      document.querySelectorAll('[data-cart-count]').forEach(el=>{
        el.textContent = total;
        el.style.display = total > 0 ? '' : 'none';
      });
      return data;
    })
    .catch(()=>{});
}
document.addEventListener('DOMContentLoaded', updateCartCount);
window.updateCartCount = updateCartCount;

function injectCartSection(data){
  if (!data || !data.sections || !data.sections[CART_SECTION]) return;
  const parsed = new DOMParser().parseFromString(data.sections[CART_SECTION], 'text/html');
  const fresh = parsed.querySelector('[data-cart-drawer]');
  const current = document.querySelector('[data-cart-drawer]');
  if (fresh && current){
    const wasOpen = current.classList.contains('open');
    current.innerHTML = fresh.innerHTML;
    if (wasOpen) current.classList.add('open');
  }
}

function cartAdd(payload){
  const body = Object.assign({}, payload, {
    sections: CART_SECTION,
    sections_url: window.location.pathname
  });
  return fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify(body)
  })
    .then(r=>r.json())
    .then(data=>{
      if (data.status && data.status >= 400) throw new Error(data.description || 'Add to cart failed');
      injectCartSection(data);
      updateCartCount();
      openPanel('cart-panel');
    });
}
window.cartAdd = cartAdd;

function cartChange(line, quantity){
  return fetch('/cart/change.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({line: line, quantity: quantity, sections: CART_SECTION, sections_url: window.location.pathname})
  })
    .then(r=>r.json())
    .then(data=>{
      injectCartSection(data);
      updateCartCount();
    });
}

document.addEventListener('click', (e)=>{
  const qtyBtn = e.target.closest('[data-cart-qty]');
  if (qtyBtn){
    e.preventDefault();
    const line = Array.from(document.querySelectorAll('[data-cart-line]')).indexOf(qtyBtn.closest('[data-cart-line]')) + 1;
    if (line < 1) return;
    const span = qtyBtn.parentElement.querySelector('span');
    const current = parseInt(span?.textContent || '1', 10);
    const next = Math.max(0, current + parseInt(qtyBtn.dataset.cartQty, 10));
    cartChange(line, next);
    return;
  }
  const rm = e.target.closest('[data-cart-remove]');
  if (rm){
    e.preventDefault();
    const line = Array.from(document.querySelectorAll('[data-cart-line]')).indexOf(rm.closest('[data-cart-line]')) + 1;
    if (line < 1) return;
    cartChange(line, 0);
  }
});

// ---- Panels (cart, menu, search) ----
const overlay = document.getElementById('overlay');
function openPanel(id){
  document.querySelectorAll('.side-panel,.search-panel').forEach(p=>p.classList.remove('open'));
  document.getElementById(id)?.classList.add('open');
  overlay?.classList.add('show');
}
function closePanels(){
  document.querySelectorAll('.side-panel.open,.search-panel.open').forEach(p=>p.classList.remove('open'));
  overlay?.classList.remove('show');
}
window.openPanel = openPanel; window.closePanels = closePanels;
overlay?.addEventListener('click', closePanels);
document.querySelectorAll('[data-close-panel]').forEach(b=>b.addEventListener('click', closePanels));
document.addEventListener('keydown', e=>{ if (e.key==='Escape') closePanels(); });

// ---- Upsell add ----
document.addEventListener('click', (e)=>{
  const btn = e.target.closest('#upsell-add');
  if (!btn) return;
  e.preventDefault();
  const id = btn.dataset.cartUpsellId;
  if (!id) return;
  cartAdd({id: parseInt(id, 10), quantity: 1});
});

// ---- Popup newsletter ----
const popup = document.getElementById('popup');
if (popup && !localStorage.getItem('lsj_popup_seen')){
  setTimeout(()=>popup.classList.add('show'), 5500);
}
document.querySelectorAll('[data-close-popup]').forEach(b=>b.addEventListener('click', ()=>{
  popup?.classList.remove('show');
  localStorage.setItem('lsj_popup_seen','1');
}));
// Mark as seen on submit so it doesn't reappear while Shopify processes the signup.
document.getElementById('popup-form')?.addEventListener('submit', ()=>{
  try { localStorage.setItem('lsj_popup_seen','1'); } catch(_){}
});

// ---- FAQ accordion ----
document.querySelectorAll('.faq-q').forEach(q=>{
  q.addEventListener('click', ()=>{
    const item = q.closest('.faq-item');
    const ans = item.querySelector('.faq-a');
    const isOpen = item.classList.toggle('open');
    ans.style.maxHeight = isOpen ? ans.scrollHeight + 'px' : 0;
  });
});

// ---- Product page tabs ----
document.querySelectorAll('.tab-heads button').forEach(b=>{
  b.addEventListener('click', ()=>{
    const target = b.dataset.tab;
    document.querySelectorAll('.tab-heads button').forEach(x=>x.classList.toggle('active', x===b));
    document.querySelectorAll('.tab-body').forEach(x=>x.hidden = x.dataset.tab!==target);
  });
});

// ---- Product image gallery ----
document.querySelectorAll('.thumbs button').forEach(t=>{
  t.addEventListener('click', ()=>{
    document.querySelectorAll('.thumbs button').forEach(x=>x.classList.remove('active'));
    t.classList.add('active');
    document.querySelector('.main-image img').src = t.dataset.full || t.querySelector('img').src;
  });
});

// ---- Product options ----
document.querySelectorAll('.color-options .swatch').forEach(s=>{
  s.addEventListener('click', ()=>{
    s.parentElement.querySelectorAll('.swatch').forEach(x=>x.classList.remove('active'));
    s.classList.add('active');
    const label = document.getElementById('color-name');
    if (label) label.textContent = s.dataset.name;
  });
});
document.querySelectorAll('.size-options button').forEach(s=>{
  s.addEventListener('click', ()=>{
    s.parentElement.querySelectorAll('button').forEach(x=>x.classList.remove('active'));
    s.classList.add('active');
  });
});

// ---- Size chart modal ----
const sizeModal = document.getElementById('size-chart-modal');
document.querySelectorAll('[data-open-size-chart]').forEach(b=>b.addEventListener('click', ()=>sizeModal?.classList.add('show')));
document.querySelectorAll('[data-close-size-chart]').forEach(b=>b.addEventListener('click', ()=>sizeModal?.classList.remove('show')));

// ---- Pre-order toggle ----
document.querySelectorAll('.preorder-toggle .switch').forEach(s=>{
  s.addEventListener('click', ()=> s.classList.toggle('active'));
});

// ---- Mobile menu ----
document.querySelector('.menu-toggle')?.addEventListener('click', ()=>openPanel('mobile-menu'));

// ---- Qty steppers (sync visible span + hidden input) ----
document.querySelectorAll('[data-qty]').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    const out = document.getElementById('qty-val');
    if (!out) return;
    let n = parseInt(out.textContent,10) || 1;
    n = Math.max(1, n + parseInt(btn.dataset.qty,10));
    out.textContent = n;
    const input = document.querySelector('[data-qty-input]');
    if (input) input.value = n;
  });
});

// ---- AJAX submit for product form (opens drawer on success) ----
document.addEventListener('submit', (e)=>{
  const form = e.target.closest('[data-product-form]');
  if (!form) return;
  e.preventDefault();
  const fd = new FormData(form);
  fd.append('sections', CART_SECTION);
  fd.append('sections_url', window.location.pathname);
  const btn = form.querySelector('[type=submit]');
  const original = btn ? btn.textContent : '';
  if (btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
  fetch('/cart/add.js', {
    method:'POST',
    headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
    body: fd
  })
    .then(r=>r.json())
    .then(data=>{
      if (data.status && data.status >= 400) throw new Error(data.description || 'Add failed');
      injectCartSection(data);
      updateCartCount();
      openPanel('cart-panel');
    })
    .catch(err=>{ alert(err.message || 'Could not add to cart.'); })
    .finally(()=>{ if (btn){ btn.disabled = false; btn.textContent = original; } });
});

// ---- Carousel buttons ----
document.querySelectorAll('[data-carousel]').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    const car = document.querySelector(btn.dataset.carousel);
    car.scrollBy({left: btn.dataset.dir==='next' ? 320 : -320, behavior:'smooth'});
  });
});

// ---- Filter swatches ----
document.querySelectorAll('.swatch-filter button').forEach(s=>{
  s.addEventListener('click', ()=>{
    s.parentElement.querySelectorAll('button').forEach(x=>x.classList.toggle('active', x===s));
  });
});

// ---- Quick add from cards ----
document.addEventListener('click', e=>{
  const b = e.target.closest('[data-quick-add]');
  if (!b) return;
  e.preventDefault();
  e.stopPropagation();
  try {
    const data = JSON.parse(b.dataset.quickAdd);
    if (data && data.id) cartAdd({id: parseInt(data.id, 10), quantity: 1});
  } catch(_){}
});

// ---- Language dropdown ----
document.querySelectorAll('.lang-dropdown').forEach(dd=>{
  const toggle = dd.querySelector('.lang-toggle');
  toggle?.addEventListener('click', e=>{
    e.stopPropagation();
    const isOpen = dd.classList.contains('open');
    document.querySelectorAll('.lang-dropdown.open').forEach(o=>o.classList.remove('open'));
    if (!isOpen) dd.classList.add('open');
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });
});
document.addEventListener('click', ()=>{
  document.querySelectorAll('.lang-dropdown.open').forEach(dd=>{
    dd.classList.remove('open');
    dd.querySelector('.lang-toggle')?.setAttribute('aria-expanded','false');
  });
});

// ---- Wishlist (localStorage) ----
const WISHLIST_KEY = 'lsj_wishlist';
function getWishlist(){
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
  catch(_){ return []; }
}
function saveWishlist(list){
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list } }));
}
function inWishlist(handle){ return getWishlist().includes(handle); }
function toggleWishlist(handle){
  const list = getWishlist();
  const i = list.indexOf(handle);
  if (i === -1){ list.push(handle); }
  else { list.splice(i, 1); }
  saveWishlist(list);
  return list.includes(handle);
}
function refreshWishlistButtons(){
  document.querySelectorAll('[data-wishlist]').forEach(btn=>{
    const handle = btn.getAttribute('data-wishlist');
    const on = inWishlist(handle);
    btn.classList.toggle('is-saved', on);
    btn.setAttribute('aria-pressed', String(on));
    if (btn.classList.contains('btn-wish')){
      btn.innerHTML = on ? '♥ Saved to wishlist' : '♡ Add to wishlist';
    } else {
      btn.innerHTML = on ? '♥' : '♡';
    }
  });
}
function showWishlistToast(message){
  let toast = document.getElementById('lsj-toast');
  if (!toast){
    toast = document.createElement('div');
    toast.id = 'lsj-toast';
    toast.setAttribute('role','status');
    toast.style.cssText = 'position:fixed;bottom:32px;left:50%;transform:translateX(-50%) translateY(20px);background:#0A0A0A;color:#FAF7F2;padding:14px 22px;font-size:.75rem;letter-spacing:.2em;text-transform:uppercase;z-index:200;opacity:0;transition:opacity .25s, transform .25s;pointer-events:none;border:1px solid #C9A84C';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  requestAnimationFrame(()=>{
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
  });
  clearTimeout(toast._timer);
  toast._timer = setTimeout(()=>{
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(-50%) translateY(20px)';
  }, 2200);
}
document.addEventListener('click', (e)=>{
  const btn = e.target.closest('[data-wishlist]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const handle = btn.getAttribute('data-wishlist');
  if (!handle) return;
  const nowSaved = toggleWishlist(handle);
  refreshWishlistButtons();
  showWishlistToast(nowSaved ? 'Saved to wishlist' : 'Removed from wishlist');
});
